import * as React from "react";
const SvgDocumentIcon = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M8.9998 17H14.9998M8.9998 13H14.9998M8.9998 9H9.9998M12.9998 3H9.79981C8.11965 3 7.27957 3 6.63783 3.32698C6.07334 3.6146 5.6144 4.07354 5.32678 4.63803C4.9998 5.27976 4.9998 6.11984 4.9998 7.8V16.2C4.9998 17.8802 4.9998 18.7202 5.32678 19.362C5.6144 19.9265 6.07334 20.3854 6.63783 20.673C7.27957 21 8.11964 21 9.7998 21H14.1998C15.88 21 16.72 21 17.3618 20.673C17.9263 20.3854 18.3852 19.9265 18.6728 19.362C18.9998 18.7202 18.9998 17.8802 18.9998 16.2V9M12.9998 3L18.9998 9M12.9998 3V5.8C12.9998 6.9201 12.9998 7.48016 13.2178 7.90798C13.4095 8.28431 13.7155 8.59027 14.0918 8.78201C14.5196 9 15.0797 9 16.1998 9H18.9998",
      stroke: "currentColor",
      strokeWidth: 1.8,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgDocumentIcon;
